import { useState, useEffect, useCallback } from "react";

const defaultSettings = {
  timeout: Infinity,
  enableHighAccuracy: true,
};

export default function usePosition() {
  const [userPositionStore, setUserPositionStore] = useState({
    userPosition: null,
    userPosLoading: true,
  });

  const [error, setError] = useState(null);

  const onChange = useCallback(({ coords }) => {
    setUserPositionStore({
      userPosition: {
        latitude: coords.latitude,
        longitude: coords.longitude,
      },
      userPosLoading: false,
    });
  }, []);

  const onError = useCallback(error => {
    setError(error.message);
    setUserPositionStore(up => ({ ...up, userPosLoading: false }));
  }, []);

  useEffect(() => {
    if (!navigator || !navigator.geolocation) {
      setError("Geolocation is not supported");
      return;
    }

    navigator.geolocation.getCurrentPosition(onChange, onError, defaultSettings);
  }, [onChange, onError]);

  return userPositionStore;
}
